export const PROJECT_NODE_TYPES = ['general', 'subproject', 'site', 'building', 'station', 'zone', 'level', 'lot', 'system', 'other'];

const makeKey = () => `node-${Date.now()}-${Math.random().toString(16).slice(2)}`;
const codeFromName = (name, fallback = 'NODE') => String(name || fallback).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().replace(/[^A-Z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40) || fallback;
export const createProjectNodeDraft = (name = 'Nouveau nœud', overrides = {}) => ({ key: makeKey(), parentKey: null, code: codeFromName(name), name, nodeType: 'other', lots: [], phases: [], inheritLots: true, inheritPhases: true, inheritDocumentRules: true, generateLda: true, generateGed: false, generateDoe: false, ...overrides });

const fromNames = (names, nodeType) => names.map((name) => createProjectNodeDraft(name, { nodeType }));
export const PROJECT_TREE_TEMPLATES = {
  simple: [],
  cable_car: fromNames(['Station 1', 'Station 2', 'Station 3', 'Station 4', 'Station 5'], 'station'),
  school: [
    ...fromNames(['Maternelle', 'Élémentaire', 'Restaurant'], 'building'),
    createProjectNodeDraft('Locaux techniques', { nodeType: 'system' }),
  ],
};

export const applyProjectTreeTemplate = (templateKey) => (PROJECT_TREE_TEMPLATES[templateKey] || []).map((node) => ({ ...node, key: makeKey(), lots: [...node.lots], phases: [...node.phases] }));
export const addProjectNode = (nodes, parentKey = null) => [...nodes, createProjectNodeDraft('Nouveau nœud', { parentKey })];
export const updateProjectNode = (nodes, key, changes) => nodes.map((node) => node.key === key ? { ...node, ...changes, ...(changes.name ? { code: codeFromName(changes.name, node.code) } : {}) } : node);
export const removeProjectNode = (nodes, key) => {
  const removed = new Set([key]);
  const queue = [key];
  while (queue.length) {
    const parentKey = queue.shift();
    for (const node of nodes) { if (node.parentKey === parentKey && !removed.has(node.key)) { removed.add(node.key); queue.push(node.key); } }
  }
  return nodes.filter((node) => !removed.has(node.key));
};
export const moveProjectNode = (nodes, key, direction) => {
  const current = nodes.find((node) => node.key === key); if (!current) return nodes;
  const siblings = nodes.filter((node) => node.parentKey === current.parentKey);
  const index = siblings.findIndex((node) => node.key === key); const target = siblings[index + direction];
  if (!target) return nodes;
  const next = [...nodes]; const left = next.findIndex((node) => node.key === key); const right = next.findIndex((node) => node.key === target.key);
  [next[left], next[right]] = [next[right], next[left]]; return next;
};
export const flattenProjectTree = (nodes, parentKey = null, depth = 1) => nodes.filter((node) => node.parentKey === parentKey).flatMap((node) => [{ ...node, depth }, ...flattenProjectTree(nodes, node.key, depth + 1)]);
